export namespace LE {
  //Generally export name matches the enum name.
  export enum HandlerStatus {
    Active = "murn:hw:lookup/HandlerStatus/Active",
    Inactive = "murn:hw:lookup/HandlerStatus/Inactive",
  }
  //Immediately breaking that rule
  export enum FederalWasteGeneratorType {
    LQG = "murn:hw:lookup/FederalWasteGeneratorType/1",
    SQG = "murn:hw:lookup/FederalWasteGeneratorType/2",
    VSQG = "murn:hw:lookup/FederalWasteGeneratorType/3",
    U = "murn:hw:lookup/FederalWasteGeneratorType/U",
    N = "murn:hw:lookup/FederalWasteGeneratorType/N",
    P = "murn:hw:lookup/FederalWasteGeneratorType/P",
  }
  export enum FederalWasteGeneratorCategory {
    Filter = "murn:hw:lookup/FederalWasteGeneratorCategory/Filter",
    NoFilter = "murn:hw:lookup/FederalWasteGeneratorCategory/NoFilter",
  }
  export enum ActivityResponse {
    Y = "murn:hw:lookup/ActivityResponse/Y",
    N = "murn:hw:lookup/ActivityResponse/N",
    U = "murn:hw:lookup/ActivityResponse/U",
    NA = "murn:hw:lookup/ActivityResponse/NULL",
  }
}
